export const teqip2=[
    {
        'sno':'1',
        'category':'Improvement in Teaching training and Learning Facilities',
        'percent':'45',
        'amount':'787.50'
    },
    {
        'sno':'2',
        'category':'Assistantships',
        'percent':'22',
        'amount':'385.00'
    },
    {
        'sno':'3',
        'category':'R&D and Consultancies',
        'percent':'3',
        'amount':'52.50'
    },
    {
        'sno':'4',
        'category':'FDP & STP',
        'percent':'14',
        'amount':'245.00'
    },
    {
        'sno':'5',
        'category':'Industrial Institute Interaction',
        'percent':'3',
        'amount':'52.50'
    },
    {
        'sno':'6',
        'category':'Management Capacity Enhancement',
        'percent':'2',
        'amount':'35.00'
    },
    {
        'sno':'7',
        'category':'Institutional Reforms',
        'percent':'2',
        'amount':'35.00'
    },
    {
        'sno':'8',
        'category':'Academic Support for Weak Students',
        'percent':'2',
        'amount':'35.00'
    },
    {
        'sno':'9',
        'category':'Incremental Operating Cost',
        'percent':'7',
        'amount':'122.50'
    },
    {
        'sno':'Total',
        'percent':'100',
        'amount':'1750.00'
    }
]